import tw, { styled } from 'twin.macro';
import MenuItem from './MenuItem';

type Props = {
  pages: ReadonlyArray<
    Queries.PageTreeItemFragment | Queries.PageTreeItemRecursiveFragment | Queries.PageFragment
  >;
};

const Menu = ({ pages }: Props) => (
  <MenuList>
    {pages.map((page) => (
      <MenuItem key={page.system.id} item={page} isFirstLevel />
    ))}
  </MenuList>
);

export const MenuList = styled.ul`
  ${tw`px-5 flex-grow`}
`;

export default Menu;
